import { alpha } from '@mui/system';
import { themeObject } from '../../lib';

export const styles = {
    root: {
        '& .MuiBackdrop-root': {
            backgroundColor: alpha(themeObject.palette.grayScale[50], 0.75),
        },
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                height: '100vh',
                width: '864px',
                maxWidth: 'none',
                maxHeight: 'none',
                boxShadow: 'none',
            },
        },
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        mb: 5,
    },
    headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        mx: '56px',
        mt: '40px',
    },
    bodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headingText: {
        fontFamily: 'Raleway',
        fontSize: '26px',
        fontWeight: 500,
        lineHeight: '30.52px',
        textAlign: 'center',
        color: themeObject.palette.primary[700],
    },
    closeButtonStyles: {
        borderRadius: '48px',
        backgroundColor: themeObject.palette.grayScale[50],
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        mt: 2,
        mx: '143.5px',
    },
    buttonStyles: {
        p: '4px 45.93px',
    },
};
